var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _g, _g2, _path484, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeeroVehicleReserve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.883 53.8405H133.328C133.328 53.8405 136.656 44.75 141.776 44.75C146.895 44.75 148.502 51.022 148.502 51.022C148.502 51.022 151.956 47.6155 154.794 47.6155C157.632 47.6155 160.098 52.1392 160.098 52.1392C160.098 52.1392 164.108 49.697 166.883 53.8405Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.594 30.471H121.914C121.914 30.471 125.419 25.375 128.186 25.375C130.954 25.375 131.765 28.758 131.765 28.758C131.765 28.758 133.725 27.19 135.516 27.4644C137.308 27.7388 137.594 30.471 137.594 30.471Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5407 58.196H23C23 58.196 27.1826 48.8586 31.6554 48.2745C36.1281 47.6904 38.2723 55.2129 38.2723 55.2129C38.2723 55.2129 41.1574 52.5552 43.4271 52.5552C45.6968 52.5552 47.4334 56.0557 47.4334 56.0557C47.4334 56.0557 51.9845 53.6567 53.5407 58.196Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2286 18.9668H64.5938C64.5938 18.9668 68.1218 12.2009 71.9869 12.1029C75.852 12.0049 77.8669 17.2224 77.8669 17.2224C77.8669 17.2224 83.8331 12.4244 85.2286 18.9668Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.533 37.685H93.6094C93.6094 37.685 96.0006 33.1182 98.5956 33.0555C101.191 32.9928 102.555 36.509 102.555 36.509C102.555 36.509 106.592 33.2711 107.533 37.685Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.413 59.5938H129.148V134.38H143.413V59.5938Z",
    fill: "#DBDBDB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 62.0234H131.359V64.8772H134.131V62.0234Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 62.0234H134.906V64.8772H137.678V62.0234Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 66.875H131.359V69.7288H134.131V66.875Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 66.875H134.906V69.7288H137.678V66.875Z",
    fill: "#EBEBEB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 71.7188H131.359V74.5725H134.131V71.7188Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 71.7188H134.906V74.5725H137.678V71.7188Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 76.5703H131.359V79.4241H134.131V76.5703Z",
    fill: "#EBEBEB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 76.5703H134.906V79.4241H137.678V76.5703Z",
    fill: "#EBEBEB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 81.4141H131.359V84.2678H134.131V81.4141Z",
    fill: "#EBEBEB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 81.4141H134.906V84.2678H137.678V81.4141Z",
    fill: "#EBEBEB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 86.2656H131.359V89.1194H134.131V86.2656Z",
    fill: "#EBEBEB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 86.2656H134.906V89.1194H137.678V86.2656Z",
    fill: "#EBEBEB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 91.1172H131.359V93.971H134.131V91.1172Z",
    fill: "#EBEBEB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 91.1172H134.906V93.971H137.678V91.1172Z",
    fill: "#EBEBEB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 95.9609H131.359V98.8147H134.131V95.9609Z",
    fill: "#EBEBEB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 95.9609H134.906V98.8147H137.678V95.9609Z",
    fill: "#EBEBEB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 100.812H131.359V103.666H134.131V100.812Z",
    fill: "#EBEBEB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 100.812H134.906V103.666H137.678V100.812Z",
    fill: "#EBEBEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 105.656H131.359V108.51H134.131V105.656Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 105.656H134.906V108.51H137.678V105.656Z",
    fill: "#EBEBEB"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 110.5H131.359V113.354H134.131V110.5Z",
    fill: "#EBEBEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 110.5H134.906V113.354H137.678V110.5Z",
    fill: "#EBEBEB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 115.352H131.359V118.205H134.131V115.352Z",
    fill: "#EBEBEB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 115.352H134.906V118.205H137.678V115.352Z",
    fill: "#EBEBEB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 120.203H131.359V123.057H134.131V120.203Z",
    fill: "#EBEBEB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 120.203H134.906V123.057H137.678V120.203Z",
    fill: "#EBEBEB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 125.047H131.359V127.901H134.131V125.047Z",
    fill: "#EBEBEB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 127.906H141.203V125.052H138.432V127.906Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 123.055H141.203V120.201H138.432V123.055Z",
    fill: "#EBEBEB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 118.211H141.203V115.357H138.432V118.211Z",
    fill: "#EBEBEB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 113.359H141.203V110.506H138.432V113.359Z",
    fill: "#EBEBEB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 108.508H141.203V105.654H138.432V108.508Z",
    fill: "#EBEBEB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 103.664H141.203V100.81H138.432V103.664Z",
    fill: "#EBEBEB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 98.8203H141.203V95.9665H138.432V98.8203Z",
    fill: "#EBEBEB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 93.9609H141.203V91.1072H138.432V93.9609Z",
    fill: "#EBEBEB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 89.1172H141.203V86.2634H138.432V89.1172Z",
    fill: "#EBEBEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 84.2734H141.203V81.4197H138.432V84.2734Z",
    fill: "#EBEBEB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 79.4219H141.203V76.5681H138.432V79.4219Z",
    fill: "#EBEBEB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 74.5781H141.203V71.7244H138.432V74.5781Z",
    fill: "#EBEBEB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 69.7266H141.203V66.8728H138.432V69.7266Z",
    fill: "#EBEBEB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M138.432 64.8828H141.203V62.0291H138.432V64.8828Z",
    fill: "#EBEBEB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M137.678 125.047H134.906V127.901H137.678V125.047Z",
    fill: "#EBEBEB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 59.5938H143.414V134.38H154.661V59.5938Z",
    fill: "#A6A6A6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 127.906H153.5V125.052H151.211V127.906Z",
    fill: "#C7C7C7"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 127.906H150.578V125.052H148.289V127.906Z",
    fill: "#C7C7C7"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 123.055H153.5V120.201H151.211V123.055Z",
    fill: "#C7C7C7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 123.055H150.578V120.201H148.289V123.055Z",
    fill: "#C7C7C7"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 118.211H153.5V115.357H151.211V118.211Z",
    fill: "#C7C7C7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 118.211H150.578V115.357H148.289V118.211Z",
    fill: "#C7C7C7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 113.359H153.5V110.506H151.211V113.359Z",
    fill: "#C7C7C7"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 113.359H150.578V110.506H148.289V113.359Z",
    fill: "#C7C7C7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 108.508H153.5V105.654H151.211V108.508Z",
    fill: "#C7C7C7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 108.508H150.578V105.654H148.289V108.508Z",
    fill: "#C7C7C7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 103.664H153.5V100.81H151.211V103.664Z",
    fill: "#C7C7C7"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 103.664H150.578V100.81H148.289V103.664Z",
    fill: "#C7C7C7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 98.8203H153.5V95.9665H151.211V98.8203Z",
    fill: "#C7C7C7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 98.8203H150.578V95.9665H148.289V98.8203Z",
    fill: "#C7C7C7"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 93.9609H153.5V91.1072H151.211V93.9609Z",
    fill: "#C7C7C7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 93.9609H150.578V91.1072H148.289V93.9609Z",
    fill: "#C7C7C7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 89.1172H153.5V86.2634H151.211V89.1172Z",
    fill: "#C7C7C7"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 89.1172H150.578V86.2634H148.289V89.1172Z",
    fill: "#C7C7C7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 84.2734H153.5V81.4197H151.211V84.2734Z",
    fill: "#C7C7C7"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 84.2734H150.578V81.4197H148.289V84.2734Z",
    fill: "#C7C7C7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 79.4219H153.5V76.5681H151.211V79.4219Z",
    fill: "#C7C7C7"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 79.4219H150.578V76.5681H148.289V79.4219Z",
    fill: "#C7C7C7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 74.5781H153.5V71.7244H151.211V74.5781Z",
    fill: "#C7C7C7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 74.5781H150.578V71.7244H148.289V74.5781Z",
    fill: "#C7C7C7"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 69.7266H153.5V66.8728H151.211V69.7266Z",
    fill: "#C7C7C7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 69.7266H150.578V66.8728H148.289V69.7266Z",
    fill: "#C7C7C7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M151.211 64.8828H153.5V62.0291H151.211V64.8828Z",
    fill: "#C7C7C7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 62.0234H145.375V64.8772H147.664V62.0234Z",
    fill: "#C7C7C7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 66.875H145.375V69.7288H147.664V66.875Z",
    fill: "#C7C7C7"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 71.7188H145.375V74.5725H147.664V71.7188Z",
    fill: "#C7C7C7"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 76.5703H145.375V79.4241H147.664V76.5703Z",
    fill: "#C7C7C7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 81.4141H145.375V84.2678H147.664V81.4141Z",
    fill: "#C7C7C7"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 86.2656H145.375V89.1194H147.664V86.2656Z",
    fill: "#C7C7C7"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 91.1172H145.375V93.971H147.664V91.1172Z",
    fill: "#C7C7C7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 95.9609H145.375V98.8147H147.664V95.9609Z",
    fill: "#C7C7C7"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 100.812H145.375V103.666H147.664V100.812Z",
    fill: "#C7C7C7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 105.656H145.375V108.51H147.664V105.656Z",
    fill: "#C7C7C7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 110.5H145.375V113.354H147.664V110.5Z",
    fill: "#C7C7C7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 115.352H145.375V118.205H147.664V115.352Z",
    fill: "#C7C7C7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 120.203H145.375V123.057H147.664V120.203Z",
    fill: "#C7C7C7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M147.664 125.047H145.375V127.901H147.664V125.047Z",
    fill: "#C7C7C7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M148.289 64.8828H150.578V62.0291H148.289V64.8828Z",
    fill: "#C7C7C7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5944 55.5625H38.7188V134.378H55.5944V55.5625Z",
    fill: "#EBEBEB"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5958 53.8359H38.3125V55.5607H55.5958V53.8359Z",
    fill: "#C7C7C7"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 58.1094H40.2422V134.385H41.9513V58.1094Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 58.1094H43.2656V134.385H44.9747V58.1094Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 58.1094H46.2969V134.385H48.006V58.1094Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 58.1094H49.3281V134.385H51.0372V58.1094Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 58.1094H52.3594V134.385H54.0685V58.1094Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 60.2891H40.2422V63.6955H41.9513V60.2891Z",
    fill: "#EBEBEB"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 60.2891H43.2656V63.6955H44.9747V60.2891Z",
    fill: "#EBEBEB"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 60.2891H46.2969V63.6955H48.006V60.2891Z",
    fill: "#EBEBEB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 60.2891H49.3281V63.6955H51.0372V60.2891Z",
    fill: "#EBEBEB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 60.2891H52.3594V63.6955H54.0685V60.2891Z",
    fill: "#EBEBEB"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 65.8203H40.2422V69.2268H41.9513V65.8203Z",
    fill: "#EBEBEB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 65.8203H43.2656V69.2268H44.9747V65.8203Z",
    fill: "#EBEBEB"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 65.8203H46.2969V69.2268H48.006V65.8203Z",
    fill: "#EBEBEB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 65.8203H49.3281V69.2268H51.0372V65.8203Z",
    fill: "#EBEBEB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 65.8203H52.3594V69.2268H54.0685V65.8203Z",
    fill: "#EBEBEB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 71.3594H40.2422V74.7659H41.9513V71.3594Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 71.3594H43.2656V74.7659H44.9747V71.3594Z",
    fill: "#EBEBEB"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 71.3594H46.2969V74.7659H48.006V71.3594Z",
    fill: "#EBEBEB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 71.3594H49.3281V74.7659H51.0372V71.3594Z",
    fill: "#EBEBEB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 71.3594H52.3594V74.7659H54.0685V71.3594Z",
    fill: "#EBEBEB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 76.8984H40.2422V80.3049H41.9513V76.8984Z",
    fill: "#EBEBEB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 76.8984H43.2656V80.3049H44.9747V76.8984Z",
    fill: "#EBEBEB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 76.8984H46.2969V80.3049H48.006V76.8984Z",
    fill: "#EBEBEB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 76.8984H49.3281V80.3049H51.0372V76.8984Z",
    fill: "#EBEBEB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 76.8984H52.3594V80.3049H54.0685V76.8984Z",
    fill: "#EBEBEB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 82.4297H40.2422V85.8362H41.9513V82.4297Z",
    fill: "#EBEBEB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 82.4297H43.2656V85.8362H44.9747V82.4297Z",
    fill: "#EBEBEB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 82.4297H46.2969V85.8362H48.006V82.4297Z",
    fill: "#EBEBEB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 82.4297H49.3281V85.8362H51.0372V82.4297Z",
    fill: "#EBEBEB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 82.4297H52.3594V85.8362H54.0685V82.4297Z",
    fill: "#EBEBEB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 87.9688H40.2422V91.3752H41.9513V87.9688Z",
    fill: "#EBEBEB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 87.9688H43.2656V91.3752H44.9747V87.9688Z",
    fill: "#EBEBEB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 87.9688H46.2969V91.3752H48.006V87.9688Z",
    fill: "#EBEBEB"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 87.9688H49.3281V91.3752H51.0372V87.9688Z",
    fill: "#EBEBEB"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 87.9688H52.3594V91.3752H54.0685V87.9688Z",
    fill: "#EBEBEB"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 93.5H40.2422V96.9065H41.9513V93.5Z",
    fill: "#EBEBEB"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 93.5H43.2656V96.9065H44.9747V93.5Z",
    fill: "#EBEBEB"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 93.5H46.2969V96.9065H48.006V93.5Z",
    fill: "#EBEBEB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 93.5H49.3281V96.9065H51.0372V93.5Z",
    fill: "#EBEBEB"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 93.5H52.3594V96.9065H54.0685V93.5Z",
    fill: "#EBEBEB"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 99.0391H40.2422V102.446H41.9513V99.0391Z",
    fill: "#EBEBEB"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 99.0391H43.2656V102.446H44.9747V99.0391Z",
    fill: "#EBEBEB"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 99.0391H46.2969V102.446H48.006V99.0391Z",
    fill: "#EBEBEB"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 99.0391H49.3281V102.446H51.0372V99.0391Z",
    fill: "#EBEBEB"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 99.0391H52.3594V102.446H54.0685V99.0391Z",
    fill: "#EBEBEB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 104.578H40.2422V107.985H41.9513V104.578Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 104.578H43.2656V107.985H44.9747V104.578Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 104.578H46.2969V107.985H48.006V104.578Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 104.578H49.3281V107.985H51.0372V104.578Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 104.578H52.3594V107.985H54.0685V104.578Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 110.109H40.2422V113.516H41.9513V110.109Z",
    fill: "#EBEBEB"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 110.109H43.2656V113.516H44.9747V110.109Z",
    fill: "#EBEBEB"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 110.109H46.2969V113.516H48.006V110.109Z",
    fill: "#EBEBEB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 110.109H49.3281V113.516H51.0372V110.109Z",
    fill: "#EBEBEB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 110.109H52.3594V113.516H54.0685V110.109Z",
    fill: "#EBEBEB"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 115.648H40.2422V119.055H41.9513V115.648Z",
    fill: "#EBEBEB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 115.648H43.2656V119.055H44.9747V115.648Z",
    fill: "#EBEBEB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 115.648H46.2969V119.055H48.006V115.648Z",
    fill: "#EBEBEB"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 115.648H49.3281V119.055H51.0372V115.648Z",
    fill: "#EBEBEB"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 115.648H52.3594V119.055H54.0685V115.648Z",
    fill: "#EBEBEB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 121.188H40.2422V124.594H41.9513V121.188Z",
    fill: "#EBEBEB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 121.188H43.2656V124.594H44.9747V121.188Z",
    fill: "#EBEBEB"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 121.188H46.2969V124.594H48.006V121.188Z",
    fill: "#EBEBEB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 121.188H49.3281V124.594H51.0372V121.188Z",
    fill: "#EBEBEB"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 121.188H52.3594V124.594H54.0685V121.188Z",
    fill: "#EBEBEB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 126.719H40.2422V130.125H41.9513V126.719Z",
    fill: "#EBEBEB"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 126.719H43.2656V130.125H44.9747V126.719Z",
    fill: "#EBEBEB"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 126.719H46.2969V130.125H48.006V126.719Z",
    fill: "#EBEBEB"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 126.719H49.3281V130.125H51.0372V126.719Z",
    fill: "#EBEBEB"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 126.719H52.3594V130.125H54.0685V126.719Z",
    fill: "#EBEBEB"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9513 132.258H40.2422V134.382H41.9513V132.258Z",
    fill: "#EBEBEB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9747 132.258H43.2656V134.382H44.9747V132.258Z",
    fill: "#EBEBEB"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M48.006 132.258H46.2969V134.382H48.006V132.258Z",
    fill: "#EBEBEB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0372 132.258H49.3281V134.382H51.0372V132.258Z",
    fill: "#EBEBEB"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0685 132.258H52.3594V134.382H54.0685V132.258Z",
    fill: "#EBEBEB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4286 55.5625H55.5938V134.378H66.4286V55.5625Z",
    fill: "#DBDBDB"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M66.899 53.8359H55.5938V55.5607H66.899V53.8359Z",
    fill: "#C7C7C7"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 58.1094H57.125V134.385H58.8341V58.1094Z",
    fill: "#C7C7C7"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 58.1094H60.1484V134.385H61.8576V58.1094Z",
    fill: "#C7C7C7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 58.1094H63.1797V134.385H64.8888V58.1094Z",
    fill: "#C7C7C7"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 60.2891H57.125V63.6955H58.8341V60.2891Z",
    fill: "#DBDBDB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 60.2891H60.1484V63.6955H61.8576V60.2891Z",
    fill: "#DBDBDB"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 60.2891H63.1797V63.6955H64.8888V60.2891Z",
    fill: "#DBDBDB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 65.8203H57.125V69.2268H58.8341V65.8203Z",
    fill: "#DBDBDB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 65.8203H60.1484V69.2268H61.8576V65.8203Z",
    fill: "#DBDBDB"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 65.8203H63.1797V69.2268H64.8888V65.8203Z",
    fill: "#DBDBDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 71.3594H57.125V74.7659H58.8341V71.3594Z",
    fill: "#DBDBDB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 71.3594H60.1484V74.7659H61.8576V71.3594Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 71.3594H63.1797V74.7659H64.8888V71.3594Z",
    fill: "#DBDBDB"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 76.8984H57.125V80.3049H58.8341V76.8984Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 76.8984H60.1484V80.3049H61.8576V76.8984Z",
    fill: "#DBDBDB"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 76.8984H63.1797V80.3049H64.8888V76.8984Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 82.4297H57.125V85.8362H58.8341V82.4297Z",
    fill: "#DBDBDB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 82.4297H60.1484V85.8362H61.8576V82.4297Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 82.4297H63.1797V85.8362H64.8888V82.4297Z",
    fill: "#DBDBDB"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 87.9688H57.125V91.3752H58.8341V87.9688Z",
    fill: "#DBDBDB"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 87.9688H60.1484V91.3752H61.8576V87.9688Z",
    fill: "#DBDBDB"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 87.9688H63.1797V91.3752H64.8888V87.9688Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 93.5H57.125V96.9065H58.8341V93.5Z",
    fill: "#DBDBDB"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 93.5H60.1484V96.9065H61.8576V93.5Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 93.5H63.1797V96.9065H64.8888V93.5Z",
    fill: "#DBDBDB"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 99.0391H57.125V102.446H58.8341V99.0391Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 99.0391H60.1484V102.446H61.8576V99.0391Z",
    fill: "#DBDBDB"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 99.0391H63.1797V102.446H64.8888V99.0391Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 104.578H57.125V107.985H58.8341V104.578Z",
    fill: "#DBDBDB"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 104.578H60.1484V107.985H61.8576V104.578Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 104.578H63.1797V107.985H64.8888V104.578Z",
    fill: "#DBDBDB"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 110.109H57.125V113.516H58.8341V110.109Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 110.109H60.1484V113.516H61.8576V110.109Z",
    fill: "#DBDBDB"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 110.109H63.1797V113.516H64.8888V110.109Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 115.648H57.125V119.055H58.8341V115.648Z",
    fill: "#DBDBDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 115.648H60.1484V119.055H61.8576V115.648Z",
    fill: "#DBDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 115.648H63.1797V119.055H64.8888V115.648Z",
    fill: "#DBDBDB"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 121.188H57.125V124.594H58.8341V121.188Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 121.188H60.1484V124.594H61.8576V121.188Z",
    fill: "#DBDBDB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 121.188H63.1797V124.594H64.8888V121.188Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 126.719H57.125V130.125H58.8341V126.719Z",
    fill: "#DBDBDB"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 126.719H60.1484V130.125H61.8576V126.719Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 126.719H63.1797V130.125H64.8888V126.719Z",
    fill: "#DBDBDB"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8341 132.258H57.125V134.382H58.8341V132.258Z",
    fill: "#DBDBDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8576 132.258H60.1484V134.382H61.8576V132.258Z",
    fill: "#DBDBDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8888 132.258H63.1797V134.382H64.8888V132.258Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3363 84.5312H17.5312V134.382H34.3363V84.5312Z",
    fill: "#EBEBEB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3357 80.3047H19.9219V84.5304H34.3357V80.3047Z",
    fill: "#C7C7C7"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 86.7344H19.375V134.378H32.4952V86.7344Z",
    fill: "#DBDBDB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 91.2812H19.375V92.4063H32.4952V91.2812Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 95.9453H19.375V97.0704H32.4952V95.9453Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 100.609H19.375V101.734H32.4952V100.609Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 105.273H19.375V106.398H32.4952V105.273Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 109.938H19.375V111.063H32.4952V109.938Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 114.602H19.375V115.727H32.4952V114.602Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 119.266H19.375V120.391H32.4952V119.266Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 123.922H19.375V125.047H32.4952V123.922Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 128.586H19.375V129.711H32.4952V128.586Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4952 133.258H19.375V134.383H32.4952V133.258Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8611 84.5312H34.3359V134.382H44.8611V84.5312Z",
    fill: "#DBDBDB"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2814 80.3047H34.3359V84.5304H43.2814V80.3047Z",
    fill: "#A6A6A6"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 86.7344H35.7812V134.378H43.8761V86.7344Z",
    fill: "#C7C7C7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 91.2812H35.7812V92.4063H43.8761V91.2812Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 95.9453H35.7812V97.0704H43.8761V95.9453Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 100.609H35.7812V101.734H43.8761V100.609Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 105.273H35.7812V106.398H43.8761V105.273Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 109.938H35.7812V111.063H43.8761V109.938Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 114.602H35.7812V115.727H43.8761V114.602Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 119.266H35.7812V120.391H43.8761V119.266Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 123.922H35.7812V125.047H43.8761V123.922Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 128.586H35.7812V129.711H43.8761V128.586Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8761 133.258H35.7812V134.383H43.8761V133.258Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M76.944 105.195H63.9531V134.38H76.944V105.195Z",
    fill: "#DBDBDB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 107.727H66V109.514H68.2971V107.727Z",
    fill: "#C7C7C7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 111.539H66V113.327H68.2971V111.539Z",
    fill: "#C7C7C7"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 115.359H66V117.147H68.2971V115.359Z",
    fill: "#C7C7C7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 119.18H66V120.967H68.2971V119.18Z",
    fill: "#C7C7C7"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 123H66V124.788H68.2971V123Z",
    fill: "#C7C7C7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 126.82H66V128.608H68.2971V126.82Z",
    fill: "#C7C7C7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2971 130.633H66V132.42H68.2971V130.633Z",
    fill: "#C7C7C7"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 107.727H69.2969V109.514H71.5979V107.727Z",
    fill: "#C7C7C7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 111.539H69.2969V113.327H71.5979V111.539Z",
    fill: "#C7C7C7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 115.359H69.2969V117.147H71.5979V115.359Z",
    fill: "#C7C7C7"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 119.18H69.2969V120.967H71.5979V119.18Z",
    fill: "#C7C7C7"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 123H69.2969V124.788H71.5979V123Z",
    fill: "#C7C7C7"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 126.82H69.2969V128.608H71.5979V126.82Z",
    fill: "#C7C7C7"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5979 130.633H69.2969V132.42H71.5979V130.633Z",
    fill: "#C7C7C7"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 107.727H72.6016V109.514H74.9026V107.727Z",
    fill: "#C7C7C7"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 111.539H72.6016V113.327H74.9026V111.539Z",
    fill: "#C7C7C7"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 115.359H72.6016V117.147H74.9026V115.359Z",
    fill: "#C7C7C7"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 119.18H72.6016V120.967H74.9026V119.18Z",
    fill: "#C7C7C7"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 123H72.6016V124.788H74.9026V123Z",
    fill: "#C7C7C7"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 126.82H72.6016V128.608H74.9026V126.82Z",
    fill: "#C7C7C7"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9026 130.633H72.6016V132.42H74.9026V130.633Z",
    fill: "#C7C7C7"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0515 105.195H76.9375V134.38H86.0515V105.195Z",
    fill: "#A6A6A6"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 132.141H85.125V130.353H83.2552V132.141Z",
    fill: "#C7C7C7"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 128.32H85.125V126.533H83.2552V128.32Z",
    fill: "#C7C7C7"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 124.5H85.125V122.712H83.2552V124.5Z",
    fill: "#C7C7C7"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 120.68H85.125V118.892H83.2552V120.68Z",
    fill: "#C7C7C7"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 116.867H85.125V115.08H83.2552V116.867Z",
    fill: "#C7C7C7"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 113.039H85.125V111.252H83.2552V113.039Z",
    fill: "#C7C7C7"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2552 109.227H85.125V107.439H83.2552V109.227Z",
    fill: "#C7C7C7"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 132.141H82.4375V130.353H80.5677V132.141Z",
    fill: "#C7C7C7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 128.32H82.4375V126.533H80.5677V128.32Z",
    fill: "#C7C7C7"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 124.5H82.4375V122.712H80.5677V124.5Z",
    fill: "#C7C7C7"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 120.68H82.4375V118.892H80.5677V120.68Z",
    fill: "#C7C7C7"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 116.867H82.4375V115.08H80.5677V116.867Z",
    fill: "#C7C7C7"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 113.039H82.4375V111.252H80.5677V113.039Z",
    fill: "#C7C7C7"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5677 109.227H82.4375V107.439H80.5677V109.227Z",
    fill: "#C7C7C7"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 132.141H79.75V130.353H77.8802V132.141Z",
    fill: "#C7C7C7"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 128.32H79.75V126.533H77.8802V128.32Z",
    fill: "#C7C7C7"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 124.5H79.75V122.712H77.8802V124.5Z",
    fill: "#C7C7C7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 120.68H79.75V118.892H77.8802V120.68Z",
    fill: "#C7C7C7"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 116.867H79.75V115.08H77.8802V116.867Z",
    fill: "#C7C7C7"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 113.039H79.75V111.252H77.8802V113.039Z",
    fill: "#C7C7C7"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8802 109.227H79.75V107.439H77.8802V109.227Z",
    fill: "#C7C7C7"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M164.617 71.7188H155.641V82.3223H164.617V71.7188Z",
    fill: "#DBDBDB"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M170.309 71.7188H164.617V82.7104H170.309V71.7188Z",
    fill: "#C7C7C7"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M170.68 76.4062H165.031V82.7175H170.68V76.4062Z",
    fill: "#DBDBDB"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M174.212 76.4062H170.688V82.7175H174.212V76.4062Z",
    fill: "#C7C7C7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M166.715 81.6328H152.203V134.38H166.715V81.6328Z",
    fill: "#EBEBEB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 83.8984H153.859V85.7644H158.422V83.8984Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 83.8984H159.695V85.7644H164.258V83.8984Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 87.0703H153.859V88.9362H158.422V87.0703Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 87.0703H159.695V88.9362H164.258V87.0703Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 90.2344H153.859V92.1003H158.422V90.2344Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 90.2344H159.695V92.1003H164.258V90.2344Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 93.3984H153.859V95.2644H158.422V93.3984Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 93.3984H159.695V95.2644H164.258V93.3984Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 96.5625H153.859V98.4284H158.422V96.5625Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 96.5625H159.695V98.4284H164.258V96.5625Z",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 99.7344H153.859V101.6H158.422V99.7344Z",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 99.7344H159.695V101.6H164.258V99.7344Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 102.898H153.859V104.764H158.422V102.898Z",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 102.898H159.695V104.764H164.258V102.898Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 106.062H153.859V107.928H158.422V106.062Z",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 106.062H159.695V107.928H164.258V106.062Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 109.227H153.859V111.092H158.422V109.227Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 109.227H159.695V111.092H164.258V109.227Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 112.398H153.859V114.264H158.422V112.398Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 112.398H159.695V114.264H164.258V112.398Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 115.562H153.859V117.428H158.422V115.562Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 115.562H159.695V117.428H164.258V115.562Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 118.727H153.859V120.592H158.422V118.727Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 118.727H159.695V120.592H164.258V118.727Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 121.891H153.859V123.757H158.422V121.891Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 121.891H159.695V123.757H164.258V121.891Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M158.422 125.055H153.859V126.921H158.422V125.055Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M164.258 125.055H159.695V126.921H164.258V125.055Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M178.471 81.6328H166.711V134.38H178.471V81.6328Z",
    fill: "#C7C7C7"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 126.922H177.289V125.056H173.542V126.922Z",
    fill: "#EBEBEB"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 126.922H172.5V125.056H168.752V126.922Z",
    fill: "#EBEBEB"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 123.758H177.289V121.892H173.542V123.758Z",
    fill: "#EBEBEB"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 123.758H172.5V121.892H168.752V123.758Z",
    fill: "#EBEBEB"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 120.594H177.289V118.728H173.542V120.594Z",
    fill: "#EBEBEB"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 120.594H172.5V118.728H168.752V120.594Z",
    fill: "#EBEBEB"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 117.422H177.289V115.556H173.542V117.422Z",
    fill: "#EBEBEB"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 117.422H172.5V115.556H168.752V117.422Z",
    fill: "#EBEBEB"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 114.258H177.289V112.392H173.542V114.258Z",
    fill: "#EBEBEB"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 114.258H172.5V112.392H168.752V114.258Z",
    fill: "#EBEBEB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 111.094H177.289V109.228H173.542V111.094Z",
    fill: "#EBEBEB"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 111.094H172.5V109.228H168.752V111.094Z",
    fill: "#EBEBEB"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 107.93H177.289V106.064H173.542V107.93Z",
    fill: "#EBEBEB"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 107.93H172.5V106.064H168.752V107.93Z",
    fill: "#EBEBEB"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 104.758H177.289V102.892H173.542V104.758Z",
    fill: "#EBEBEB"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 104.758H172.5V102.892H168.752V104.758Z",
    fill: "#EBEBEB"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 101.594H177.289V99.7278H173.542V101.594Z",
    fill: "#EBEBEB"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 101.594H172.5V99.7278H168.752V101.594Z",
    fill: "#EBEBEB"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 98.4297H177.289V96.5638H173.542V98.4297Z",
    fill: "#EBEBEB"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 98.4297H172.5V96.5638H168.752V98.4297Z",
    fill: "#EBEBEB"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 95.2656H177.289V93.3997H173.542V95.2656Z",
    fill: "#EBEBEB"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 95.2656H172.5V93.3997H168.752V95.2656Z",
    fill: "#EBEBEB"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 92.1016H177.289V90.2356H173.542V92.1016Z",
    fill: "#EBEBEB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 92.1016H172.5V90.2356H168.752V92.1016Z",
    fill: "#EBEBEB"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 88.9297H177.289V87.0638H173.542V88.9297Z",
    fill: "#EBEBEB"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 88.9297H172.5V87.0638H168.752V88.9297Z",
    fill: "#EBEBEB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M173.542 85.7656H177.289V83.8997H173.542V85.7656Z",
    fill: "#EBEBEB"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M168.752 85.7656H172.5V83.8997H168.752V85.7656Z",
    fill: "#EBEBEB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M114.291 100.008H97.1719V134.378H114.291V100.008Z",
    fill: "#C7C7C7"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 102.984H99.8594V105.089H102.89V102.984Z",
    fill: "#DBDBDB"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 107.484H99.8594V109.589H102.89V107.484Z",
    fill: "#DBDBDB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 111.984H99.8594V114.089H102.89V111.984Z",
    fill: "#DBDBDB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 116.477H99.8594V118.582H102.89V116.477Z",
    fill: "#DBDBDB"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 120.977H99.8594V123.082H102.89V120.977Z",
    fill: "#DBDBDB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 125.477H99.8594V127.582H102.89V125.477Z",
    fill: "#DBDBDB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 129.969H99.8594V132.074H102.89V129.969Z",
    fill: "#DBDBDB"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 102.984H104.219V105.089H107.249V102.984Z",
    fill: "#DBDBDB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 107.484H104.219V109.589H107.249V107.484Z",
    fill: "#DBDBDB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 111.984H104.219V114.089H107.249V111.984Z",
    fill: "#DBDBDB"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 116.477H104.219V118.582H107.249V116.477Z",
    fill: "#DBDBDB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 120.977H104.219V123.082H107.249V120.977Z",
    fill: "#DBDBDB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 125.477H104.219V127.582H107.249V125.477Z",
    fill: "#DBDBDB"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 129.969H104.219V132.074H107.249V129.969Z",
    fill: "#DBDBDB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 102.984H108.57V105.089H111.6V102.984Z",
    fill: "#DBDBDB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 107.484H108.57V109.589H111.6V107.484Z",
    fill: "#DBDBDB"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 111.984H108.57V114.089H111.6V111.984Z",
    fill: "#DBDBDB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 116.477H108.57V118.582H111.6V116.477Z",
    fill: "#DBDBDB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 120.977H108.57V123.082H111.6V120.977Z",
    fill: "#DBDBDB"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 125.477H108.57V127.582H111.6V125.477Z",
    fill: "#DBDBDB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M111.6 129.969H108.57V132.074H111.6V129.969Z",
    fill: "#DBDBDB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M114.286 96.4297H102.891V100.013H114.286V96.4297Z",
    fill: "#DBDBDB"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M114.287 94.2109H107.062V96.4297H114.287V94.2109Z",
    fill: "#EBEBEB"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M126.3 100.008H114.289V134.378H126.3V100.008Z",
    fill: "#A6A6A6"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 131.742H125.078V129.637H122.612V131.742Z",
    fill: "#C7C7C7"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 127.242H125.078V125.137H122.612V127.242Z",
    fill: "#C7C7C7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 122.742H125.078V120.637H122.612V122.742Z",
    fill: "#C7C7C7"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 118.242H125.078V116.137H122.612V118.242Z",
    fill: "#C7C7C7"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 113.75H125.078V111.645H122.612V113.75Z",
    fill: "#C7C7C7"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 109.25H125.078V107.145H122.612V109.25Z",
    fill: "#C7C7C7"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M122.612 104.758H125.078V102.653H122.612V104.758Z",
    fill: "#C7C7C7"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 131.742H121.523V129.637H119.058V131.742Z",
    fill: "#C7C7C7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 127.242H121.523V125.137H119.058V127.242Z",
    fill: "#C7C7C7"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 122.742H121.523V120.637H119.058V122.742Z",
    fill: "#C7C7C7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 118.242H121.523V116.137H119.058V118.242Z",
    fill: "#C7C7C7"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 113.75H121.523V111.645H119.058V113.75Z",
    fill: "#C7C7C7"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 109.25H121.523V107.145H119.058V109.25Z",
    fill: "#C7C7C7"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M119.058 104.758H121.523V102.653H119.058V104.758Z",
    fill: "#C7C7C7"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 131.742H117.984V129.637H115.519V131.742Z",
    fill: "#C7C7C7"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 127.242H117.984V125.137H115.519V127.242Z",
    fill: "#C7C7C7"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 122.742H117.984V120.637H115.519V122.742Z",
    fill: "#C7C7C7"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 118.242H117.984V116.137H115.519V118.242Z",
    fill: "#C7C7C7"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 113.75H117.984V111.645H115.519V113.75Z",
    fill: "#C7C7C7"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 109.25H117.984V107.145H115.519V109.25Z",
    fill: "#C7C7C7"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M115.519 104.758H117.984V102.653H115.519V104.758Z",
    fill: "#C7C7C7"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M124.481 96.4297H114.289V100.013H124.481V96.4297Z",
    fill: "#C7C7C7"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M119.812 94.2109H114.289V96.4297H119.812V94.2109Z",
    fill: "#DBDBDB"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0029 182.535C139.055 182.535 172.334 179.83 172.334 176.494C172.334 173.158 139.055 170.453 98.0029 170.453C56.951 170.453 23.6719 173.158 23.6719 176.494C23.6719 179.83 56.951 182.535 98.0029 182.535Z",
    fill: "#EBEBEB"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3281 137.227L35.9944 137.133L56.6645 137.098L97.997 137.031L139.329 137.098L160 137.129L180.666 137.227L160 137.321L139.329 137.357L97.997 137.423L56.6645 137.357L35.9944 137.321L15.3281 137.227Z",
    fill: "#263238"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M179.781 134.375H16.2109V137.225H179.781V134.375Z",
    fill: "#C7C7C7"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M27.681 134.375C27.9371 135.308 27.9371 136.292 27.681 137.225C27.5432 136.763 27.4771 136.283 27.485 135.802C27.4785 135.319 27.5446 134.838 27.681 134.375Z",
    fill: "#263238"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4577 134.375C40.5941 134.838 40.6601 135.319 40.6537 135.802C40.6616 136.283 40.5955 136.763 40.4577 137.225C40.2016 136.292 40.2016 135.308 40.4577 134.375Z",
    fill: "#263238"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2513 134.375C53.5074 135.308 53.5074 136.292 53.2513 137.225C53.1135 136.763 53.0474 136.283 53.0553 135.802C53.0488 135.319 53.1149 134.838 53.2513 134.375Z",
    fill: "#263238"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0358 134.375C66.1722 134.838 66.2383 135.319 66.2318 135.802C66.2397 136.283 66.1736 136.763 66.0358 137.225C65.7797 136.292 65.7797 135.308 66.0358 134.375Z",
    fill: "#263238"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8216 134.375C79.0777 135.308 79.0777 136.292 78.8216 137.225C78.6838 136.763 78.6177 136.283 78.6256 135.802C78.6192 135.319 78.6852 134.838 78.8216 134.375Z",
    fill: "#263238"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5983 134.375C91.7347 134.838 91.8008 135.319 91.7943 135.802C91.8022 136.283 91.7361 136.763 91.5983 137.225C91.3422 136.292 91.3422 135.308 91.5983 134.375Z",
    fill: "#263238"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M104.392 134.375C104.648 135.308 104.648 136.292 104.392 137.225C104.254 136.763 104.188 136.283 104.196 135.802C104.189 135.319 104.256 134.838 104.392 134.375Z",
    fill: "#263238"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M117.176 134.375C117.313 134.838 117.379 135.319 117.372 135.802C117.38 136.283 117.314 136.763 117.176 137.225C116.92 136.292 116.92 135.308 117.176 134.375Z",
    fill: "#263238"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M129.962 134.375C130.218 135.308 130.218 136.292 129.962 137.225C129.824 136.763 129.758 136.283 129.766 135.802C129.76 135.319 129.826 134.838 129.962 134.375Z",
    fill: "#263238"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M142.739 134.375C142.875 134.838 142.941 135.319 142.935 135.802C142.943 136.283 142.877 136.763 142.739 137.225C142.483 136.292 142.483 135.308 142.739 134.375Z",
    fill: "#263238"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M155.533 134.375C155.789 135.308 155.789 136.292 155.533 137.225C155.395 136.763 155.329 136.283 155.337 135.802C155.33 135.319 155.396 134.838 155.533 134.375Z",
    fill: "#263238"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M168.317 134.375C168.453 134.838 168.52 135.319 168.513 135.802C168.521 136.283 168.455 136.763 168.317 137.225C168.061 136.292 168.061 135.308 168.317 134.375Z",
    fill: "#263238"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6558 134.376C34.6558 134.376 34.3265 132.835 33.668 132.6C33.0094 132.365 32.6057 133.055 32.6057 133.055C32.6057 133.055 32.4528 131.581 31.5159 131.142C30.579 130.703 29.8813 131.604 29.8813 131.604C29.8813 131.604 29.1639 129.75 27.8821 129.75C26.6002 129.75 25.9573 132.494 25.9573 132.494C25.9573 132.494 25.2008 131.683 24.4246 132.141C23.6485 132.6 23.6406 134.403 23.6406 134.403L34.6558 134.376Z",
    fill: "#37474F"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M143.96 134.376C143.96 134.376 143.631 132.835 142.973 132.6C142.314 132.365 141.914 133.055 141.914 133.055C141.914 133.055 141.757 131.581 140.824 131.142C139.892 130.703 139.19 131.604 139.19 131.604C139.19 131.604 138.472 129.75 137.195 129.75C135.917 129.75 135.266 132.494 135.266 132.494C135.266 132.494 134.513 131.683 133.737 132.141C132.961 132.6 132.953 134.403 132.953 134.403L143.96 134.376Z",
    fill: "#455A64"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7711 134.375H52.1875C52.1875 134.375 52.5795 132.745 53.3361 132.627C53.5707 132.604 53.8068 132.654 54.0117 132.771C54.2167 132.887 54.3806 133.064 54.4807 133.278C54.4807 133.278 54.4454 131 55.8801 130.612C57.3149 130.224 58.5144 132.235 58.5144 132.235C58.5144 132.235 59.416 131.087 60.639 131.161C61.8621 131.236 62.1796 133.121 62.1796 133.121C62.1796 133.121 63.2772 132.466 63.7711 134.375Z",
    fill: "#37474F"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3612 134.376H18.2656C18.2656 134.376 18.2656 133.471 18.8771 133.228C19.0401 133.157 19.2215 133.142 19.394 133.184C19.5665 133.225 19.7208 133.322 19.8336 133.459C19.8336 133.459 20.0767 131.789 21.1939 131.789C22.3111 131.789 22.8481 133.228 22.8481 133.228C22.9429 133.09 23.0758 132.984 23.2304 132.921C23.3851 132.858 23.5547 132.842 23.7183 132.875C24.3377 132.953 24.3612 134.376 24.3612 134.376Z",
    fill: "#455A64"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5565 134.376H62.4609C62.4609 134.376 62.4609 133.471 63.0725 133.228C63.2354 133.157 63.4168 133.142 63.5893 133.184C63.7618 133.225 63.9161 133.322 64.0289 133.459C64.0289 133.459 64.2759 131.789 65.3931 131.789C66.5103 131.789 67.0434 133.228 67.0434 133.228C67.1382 133.09 67.2711 132.984 67.4257 132.921C67.5804 132.858 67.75 132.842 67.9137 132.875C68.533 132.953 68.5565 134.376 68.5565 134.376Z",
    fill: "#455A64"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M168.83 134.376H162.734C162.734 134.376 162.734 133.471 163.346 133.228C163.509 133.157 163.69 133.142 163.863 133.184C164.035 133.225 164.19 133.322 164.302 133.459C164.302 133.459 164.545 131.789 165.663 131.789C166.78 131.789 167.317 133.228 167.317 133.228C167.411 133.09 167.544 132.983 167.699 132.92C167.854 132.858 168.023 132.842 168.187 132.875C168.806 132.953 168.83 134.376 168.83 134.376Z",
    fill: "#455A64"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M177.723 134.378H167.672C167.672 134.378 167.695 132.881 168.683 132.485C168.952 132.372 169.25 132.349 169.532 132.42C169.815 132.491 170.067 132.651 170.251 132.877C170.251 132.877 170.643 130.133 172.497 130.133C174.352 130.133 175.218 132.497 175.218 132.497C175.374 132.27 175.593 132.094 175.848 131.99C176.103 131.886 176.383 131.859 176.653 131.912C177.684 132.034 177.723 134.378 177.723 134.378Z",
    fill: "#37474F"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M106.113 18.4766H90.6797V27.222H106.113V18.4766Z",
    fill: "#263238"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M108.285 15.5391H88.4922V21.2611H108.285V15.5391Z",
    fill: "#455A64"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6119 27.1303L67.4062 31.3359L74.0497 37.9794L78.2553 33.7738L71.6119 27.1303Z",
    fill: "#263238"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6115 23.6542L63.9297 30.3359L68.2693 34.6756L74.9511 27.9938L70.6115 23.6542Z",
    fill: "#455A64"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M118.544 33.7631L122.75 37.9688L129.393 31.3253L125.188 27.1196L118.544 33.7631Z",
    fill: "#263238"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M121.818 27.9979L128.5 34.6797L132.84 30.34L126.158 23.6583L121.818 27.9979Z",
    fill: "#455A64"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M134.902 72.2016C139.634 52.0284 127.116 31.8391 106.943 27.1075C86.7694 22.376 66.5801 34.8938 61.8485 55.067C57.1169 75.2402 69.6348 95.4294 89.808 100.161C109.981 104.893 130.17 92.3747 134.902 72.2016Z",
    fill: "#455A64"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9348 98.8228C117.703 98.8228 133.729 82.7972 133.729 63.0286C133.729 43.26 117.703 27.2344 97.9348 27.2344C78.1662 27.2344 62.1406 43.26 62.1406 63.0286C62.1406 82.7972 78.1662 98.8228 97.9348 98.8228Z",
    fill: "#263238"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M129.664 68.0466C132.19 50.7696 120.233 34.7156 102.956 32.189C85.6788 29.6624 69.6248 41.62 67.0983 58.8969C64.5717 76.1739 76.5292 92.2279 93.8062 94.7545C111.083 97.2811 127.137 85.3236 129.664 68.0466Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M130.01 63.479H98.4219V31.8906C106.8 31.8906 114.834 35.2187 120.758 41.1427C126.682 47.0666 130.01 55.1013 130.01 63.479Z",
    fill: "#F34F42"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7075 34.1562H98.0938V38.9487H98.7075V34.1562Z",
    fill: "#C7C7C7"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9924 37.9197L83.4609 38.2266L85.8571 42.3769L86.3886 42.0701L83.9924 37.9197Z",
    fill: "#C7C7C7"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M73.135 48.5388L72.8281 49.0703L76.9785 51.4665L77.2853 50.935L73.135 48.5388Z",
    fill: "#C7C7C7"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8705 63.1797H69.0781V63.7934H73.8705V63.1797Z",
    fill: "#C7C7C7"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0756 75.7835L73.9062 78.1797L74.2131 78.7136L78.3825 76.3174L78.0756 75.7835Z",
    fill: "#C7C7C7"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8628 84.575L83.4688 88.7266L84.0004 89.0331L86.3944 84.8815L85.8628 84.575Z",
    fill: "#C7C7C7"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7075 88.0078H98.0938V92.8002H98.7075V88.0078Z",
    fill: "#C7C7C7"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M110.922 84.5603L110.391 84.8672L112.787 89.0175L113.318 88.7107L110.922 84.5603Z",
    fill: "#C7C7C7"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M119.791 75.4529L119.484 75.9844L123.635 78.3806L123.942 77.8491L119.791 75.4529Z",
    fill: "#C7C7C7"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M127.714 63.1797H122.922V63.7934H127.714V63.1797Z",
    fill: "#C7C7C7"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M123.635 48.5413L119.484 50.9375L119.791 51.469L123.942 49.0728L123.635 48.5413Z",
    fill: "#C7C7C7"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M112.785 37.9269L110.391 42.0781L110.922 42.3848L113.317 38.2336L112.785 37.9269Z",
    fill: "#C7C7C7"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6127 40.6028L100.021 65.3591L96.8438 65.3139L97.7553 40.5938L98.6127 40.6028Z",
    fill: "#F34F42"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M99.481 63.4827C99.481 63.6991 99.4167 63.9106 99.2963 64.0904C99.1759 64.2701 99.0048 64.4101 98.8047 64.4925C98.6047 64.5749 98.3846 64.596 98.1725 64.5531C97.9605 64.5102 97.7659 64.4053 97.6135 64.2517C97.4612 64.098 97.3579 63.9026 97.3168 63.6902C97.2757 63.4778 97.2986 63.2579 97.3826 63.0585C97.4666 62.8591 97.608 62.6892 97.7888 62.5703C97.9696 62.4514 98.1816 62.3889 98.3979 62.3907C98.5409 62.3907 98.6825 62.419 98.8145 62.474C98.9465 62.5289 99.0663 62.6095 99.167 62.7111C99.2677 62.8126 99.3472 62.933 99.4011 63.0655C99.455 63.1979 99.4822 63.3397 99.481 63.4827Z",
    fill: "#F34F42"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M121.319 63.8561L96.5625 65.255L96.6076 62.0781L121.328 62.9897L121.319 63.8561Z",
    fill: "#263238"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M99.481 63.4827C99.481 63.6991 99.4167 63.9106 99.2963 64.0904C99.1759 64.2701 99.0048 64.4101 98.8047 64.4925C98.6047 64.5749 98.3846 64.596 98.1725 64.5531C97.9605 64.5102 97.7659 64.4053 97.6135 64.2517C97.4612 64.098 97.3579 63.9026 97.3168 63.6902C97.2757 63.4778 97.2986 63.2579 97.3826 63.0585C97.4666 62.8591 97.608 62.6892 97.7888 62.5703C97.9696 62.4514 98.1816 62.3889 98.3979 62.3907C98.5409 62.3907 98.6825 62.419 98.8145 62.474C98.9465 62.5289 99.0663 62.6095 99.167 62.7111C99.2677 62.8126 99.3472 62.933 99.4011 63.0655C99.455 63.1979 99.4822 63.3397 99.481 63.4827Z",
    fill: "#F34F42"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M112.822 150.93H70.0391V155.661H112.822V150.93Z",
    fill: "#F34F42"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4375 109.422H34.864L50.544 127.36H48.1175L32.4375 109.422Z",
    fill: "#A6A6A6"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0011 108H29.2812V109.419H63.0011V108Z",
    fill: "#A6A6A6"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5938 109.422H44.0202L59.7002 127.36H57.2738L41.5938 109.422Z",
    fill: "#A6A6A6"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1903 142.492C69.3736 142.492 76.4335 150.955 76.4335 160.916C76.4335 170.877 69.895 179.148 58.0135 179.148C44.8658 179.148 38.5859 168.69 38.5859 160.826C38.5859 152.963 44.8579 142.492 57.1903 142.492Z",
    fill: "#37474F"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M55.312 142.492C66.8956 142.492 73.6028 150.955 73.6028 160.916C73.6028 170.877 67.3896 179.148 56.0882 179.148C43.5873 179.148 37.625 168.674 37.625 160.81C37.625 152.947 43.5873 142.492 55.312 142.492Z",
    fill: "#263238"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4402 149.641C62.4962 149.641 66.5847 154.799 66.5847 160.868C66.5847 166.936 62.798 171.973 55.9145 171.973C48.294 171.973 44.6562 165.599 44.6562 160.805C44.6562 156.011 48.294 149.641 55.4402 149.641Z",
    fill: "#C7C7C7"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6819 120.158V118.555L50.6826 119.876V123.482C50.6826 123.482 38.8089 136.595 37.6094 150.224L78.7223 151.095L85.3275 150.93H93.438V142.69C93.438 142.69 87.3071 138.221 88.3812 129.092C88.7379 126.061 91.6819 120.158 91.6819 120.158Z",
    fill: "#F34F42"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8946 149.182C74.4673 149.966 68.2306 151.091 56.4079 151.408C45.7651 151.694 37.8153 151.459 37.1999 150.773C36.5845 150.087 38.1525 137.955 45.3574 131.385C52.5624 124.815 62.7622 123.87 69.4889 127.79C75.4042 131.228 79.8181 139.966 74.8946 149.182Z",
    fill: "#F34F42"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.8972 137.697C76.2651 134.824 74.8072 132.199 72.7028 130.144C70.5932 128.03 67.9589 126.516 65.0706 125.757C61.8487 124.953 58.4743 124.989 55.2706 125.863C53.6672 126.283 52.1168 126.884 50.6489 127.654C49.0991 128.487 47.6385 129.476 46.2899 130.606C45.9292 130.904 45.5647 131.202 45.2079 131.508C45.1766 131.531 45.2079 131.574 45.255 131.551C46.6119 130.358 48.0809 129.298 49.6415 128.387C51.0655 127.574 52.5763 126.923 54.1455 126.447C57.2567 125.474 60.5606 125.288 63.7613 125.906C66.654 126.487 69.335 127.842 71.519 129.826C73.6234 131.721 75.1712 134.153 75.9956 136.862C76.9756 140.163 76.6542 143.797 75.6781 147.054C75.5487 147.493 75.4076 147.925 75.2626 148.356C75.2626 148.403 75.3175 148.419 75.3331 148.375C76.6503 144.993 77.6342 141.347 76.8972 137.697Z",
    fill: "black"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3966 152.661C41.2583 152.661 37.4794 152.442 35.5625 151.681L36.4523 149.443C38.6946 150.333 45.7153 150.317 57.0127 150.188C65.3584 150.09 71.5167 149.302 75.3583 147.836L76.2168 150.086C72.0616 151.654 65.7896 152.485 57.0402 152.587C53.7199 152.634 50.8583 152.661 48.3966 152.661Z",
    fill: "#DBDBDB"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3519 119.606C92.3519 119.606 92.6263 110.637 92.3519 110.284C92.0775 109.931 50.5725 109.182 49.3299 109.292C48.0872 109.402 47.9618 119.876 48.0559 120.366C48.15 120.856 91.27 119.7 92.3519 119.606Z",
    fill: "#37474F"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2464 110.47C96.1249 110.329 90.8643 110.18 90.5742 110.172C90.2841 110.164 90.1822 119.725 90.339 119.717C90.4958 119.709 96.0544 119.788 96.2386 119.584C96.4228 119.38 96.5091 110.776 96.2464 110.47Z",
    fill: "#455A64"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1773 109.305C67.0286 109.46 66.9314 109.657 66.8989 109.869C66.8497 110.093 66.8144 110.319 66.7931 110.547C66.7421 111.002 66.7147 111.465 66.6912 111.923C66.652 112.848 66.6285 113.777 66.6128 114.71C66.5971 115.643 66.5736 116.568 66.6128 117.49C66.6163 117.946 66.6477 118.401 66.7069 118.854C66.7304 119.072 66.7818 119.287 66.8597 119.493C66.8884 119.585 66.9391 119.669 67.0074 119.737C67.0757 119.805 67.1595 119.856 67.2517 119.885C67.1483 119.882 67.0479 119.849 66.9624 119.791C66.877 119.732 66.81 119.651 66.7696 119.555C66.6599 119.35 66.5744 119.133 66.5148 118.909C66.4039 118.449 66.3317 117.981 66.2992 117.509C66.2268 116.57 66.2033 115.628 66.2286 114.687C66.2521 113.75 66.2913 112.809 66.3972 111.872C66.4481 111.404 66.5226 110.938 66.6206 110.477C66.6753 110.249 66.7421 110.024 66.8205 109.803C66.8833 109.61 66.993 109.371 67.1773 109.305Z",
    fill: "#455A64"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M30.843 107.977H70.0391V83.6098H30.843V107.977Z",
    fill: "#37474F"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8382 107.977H59.1562V83.6098H30.8382L30.8382 107.977Z",
    fill: "#263238"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5302 83.6094H43.4844V107.976H46.5302V83.6094Z",
    fill: "#F34F42"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1646 81.3516H30.0469V83.6056H59.1646V81.3516Z",
    fill: "#37474F"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9123 81.3516H59.1562V83.6056H70.9123V81.3516Z",
    fill: "#263238"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7781 81.3516H43.2188V83.6056H46.7781V81.3516Z",
    fill: "#F34F42"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M146.675 142.344C158.862 142.344 165.918 150.807 165.918 160.768C165.918 170.728 159.379 178.988 147.494 178.988C134.342 178.988 128.062 168.529 128.062 160.67C128.062 152.81 134.342 142.344 146.675 142.344Z",
    fill: "#37474F"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M144.8 142.344C156.384 142.344 163.095 150.807 163.095 160.768C163.095 170.728 156.878 178.988 145.58 178.988C133.08 178.988 127.109 168.529 127.109 160.67C127.109 152.81 133.08 142.344 144.8 142.344Z",
    fill: "#263238"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M144.921 149.492C151.977 149.492 156.069 154.651 156.069 160.719C156.069 166.787 152.282 171.824 145.395 171.824C137.778 171.824 134.141 165.451 134.141 160.66C134.141 155.87 137.778 149.492 144.921 149.492Z",
    fill: "#C7C7C7"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M126.962 100.728H122.168L118.883 95.9062H124.5L126.962 100.728Z",
    fill: "#F34F42"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M118.883 95.9062L120.808 98.7286L122.168 100.728H126.962L125.664 98.1877L124.496 95.9062H118.883Z",
    fill: "#F34F42"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M118.883 95.9062L120.808 98.7286L125.664 98.1877L124.496 95.9062H118.883Z",
    fill: "black"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M138.613 136.71L133.945 137.784L129.664 133.817L135.136 132.562L138.613 136.71Z",
    fill: "#F34F42"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M129.664 133.817L132.169 136.141L133.941 137.784L138.617 136.71L136.783 134.526L135.136 132.562L129.664 133.817Z",
    fill: "#F34F42"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.664 133.817L132.169 136.141L136.783 134.526L135.136 132.562L129.664 133.817Z",
    fill: "black"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M164.863 144.694L160.327 147.077C160.327 147.077 147.191 144.694 138.767 146.497C130.343 148.3 128.07 152.8 128.07 152.8H123.812C123.812 152.8 127.466 139.821 133.663 135.109C139.861 130.397 149.822 131.452 155.329 134.419C160.837 137.387 164.863 144.694 164.863 144.694Z",
    fill: "#F34F42"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.847 146.177C158.969 145.26 158.017 144.416 157.002 143.653C155.995 142.871 154.931 142.166 153.819 141.544C151.662 140.346 149.296 139.569 146.849 139.255C142.059 138.667 137.049 140.062 133.521 143.743C131.537 145.829 130.126 148.388 128.785 150.972C128.766 151.011 128.821 151.042 128.84 151.003C129.976 148.732 131.41 146.622 133.105 144.731C134.738 142.948 136.771 141.578 139.036 140.733C143.556 139.074 148.444 139.709 152.788 141.713C154.031 142.276 155.231 142.931 156.378 143.673C157.551 144.462 158.683 145.312 159.769 146.217C159.776 146.223 159.785 146.227 159.794 146.228C159.804 146.23 159.813 146.228 159.822 146.224C159.83 146.22 159.837 146.213 159.842 146.205C159.846 146.196 159.848 146.187 159.847 146.177Z",
    fill: "black"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M110.007 98.1378C109.937 98.3025 100.47 100.043 100.47 100.043C100.47 100.043 98.9021 98.9845 99.8704 97.6439L109.369 95.5938C109.734 95.8933 109.993 96.3023 110.108 96.7603C110.223 97.2184 110.188 97.7013 110.007 98.1378Z",
    fill: "#263238"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M129.872 85.8935V97.1243C129.872 97.1243 123.808 96.5951 122.193 96.5402C120.578 96.4853 113.4 97.4143 113.4 97.4143L112.844 94.8977C112.844 94.8977 118.379 92.9651 120.731 91.4559C123.083 89.9467 125.792 87.0616 127.246 86.4227C128.069 86.0465 128.968 85.8654 129.872 85.8935Z",
    fill: "#F34F42"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M113.432 94.5859C113.793 94.9567 114.065 95.4043 114.228 95.8951C114.391 96.386 114.44 96.9073 114.373 97.4201C114.373 97.4201 109.853 98.2472 109.798 98.2472C109.836 97.7155 109.707 97.1852 109.43 96.73C109.152 96.2749 108.74 95.9173 108.25 95.7071L113.432 94.5859Z",
    fill: "#DBDBDB"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M129.94 97.1253C131.581 97.1253 132.911 94.6121 132.911 91.5119C132.911 88.4117 131.581 85.8984 129.94 85.8984C128.299 85.8984 126.969 88.4117 126.969 91.5119C126.969 94.6121 128.299 97.1253 129.94 97.1253Z",
    fill: "#DBDBDB"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M130.122 96.5273C131.527 96.5273 132.666 94.2844 132.666 91.5176C132.666 88.7508 131.527 86.5078 130.122 86.5078C128.717 86.5078 127.578 88.7508 127.578 91.5176C127.578 94.2844 128.717 96.5273 130.122 96.5273Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M130.888 100.742C131.876 102.189 135.831 121.859 136.607 122.847C137.383 123.835 138.869 123.905 138.869 123.905L141.484 130.405C141.484 130.405 134.988 132.455 131.382 135.419C126.721 139.248 122.413 151.945 122.413 151.945C121.707 152.439 112.95 156.042 110.547 156.183C110.547 156.183 121.715 143.921 122.624 126.951C122.977 120.377 118.932 111.118 118.669 106.532C118.379 101.609 119.869 100.742 122.483 100.742H130.888Z",
    fill: "#F34F42"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M110.014 157.587L108.266 155.933C118.066 145.56 121.68 129.218 121.394 124.757C121.245 122.472 120.512 119.916 119.732 117.207C118.901 114.318 117.96 111.045 117.56 107.489C117.188 104.189 117.56 102.056 118.685 100.782C119.81 99.5082 121.355 99.5121 122.382 99.5161H131.711V101.923H122.378C121.48 101.923 120.868 101.954 120.48 102.389C120.092 102.825 119.587 103.957 119.955 107.223C120.347 110.574 121.206 113.608 122.048 116.541C122.864 119.379 123.616 122.056 123.797 124.6C124.102 129.363 120.343 146.701 110.014 157.587Z",
    fill: "#DBDBDB"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M136.654 128.22C137.203 130.242 138.932 131.528 140.516 131.097C142.099 130.666 142.942 128.678 142.389 126.659C141.837 124.641 140.108 123.347 138.524 123.778C136.941 124.209 136.102 126.201 136.654 128.22Z",
    fill: "#DBDBDB"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M137.249 128.058C137.739 129.861 139.236 131.022 140.593 130.653C141.949 130.285 142.647 128.525 142.161 126.733C141.675 124.942 140.173 123.77 138.821 124.138C137.469 124.507 136.759 126.255 137.249 128.058Z",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.724 127.889C129.289 125.854 128.818 123.828 128.411 121.789C128.003 119.751 127.627 117.709 127.309 115.658C126.999 113.749 126.666 111.821 126.545 109.888C126.423 107.869 126.545 105.831 127.525 104.008C127.527 104.005 127.528 104.001 127.529 103.997C127.529 103.992 127.529 103.988 127.528 103.984C127.527 103.98 127.525 103.976 127.522 103.973C127.52 103.97 127.516 103.967 127.513 103.965C127.509 103.963 127.505 103.962 127.501 103.961C127.497 103.961 127.493 103.961 127.489 103.962C127.485 103.963 127.481 103.965 127.478 103.968C127.475 103.97 127.472 103.973 127.47 103.977C126.462 105.447 126.133 107.215 126.078 108.967C126.083 110.899 126.254 112.827 126.588 114.729C127.16 118.908 127.945 123.054 128.94 127.152C129.508 129.469 130.241 131.746 131.025 133.996C131.025 134.003 131.028 134.01 131.033 134.016C131.038 134.021 131.045 134.024 131.053 134.024C131.06 134.024 131.067 134.021 131.072 134.016C131.077 134.01 131.08 134.003 131.08 133.996C130.612 131.95 130.16 129.914 129.724 127.889Z",
    fill: "black"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.4348 142.69V150.922H86.4101V144.689C86.4101 144.689 82.4901 142.71 81.7061 135.509C81.0005 128.986 86.2063 120.279 87.1941 118.7L91.6669 118.555V120.158C91.6669 120.158 88.7229 126.061 88.3662 129.092C87.3039 138.221 93.4348 142.69 93.4348 142.69Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24146_365316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.2289 135.875C56.1758 135.875 56.1227 135.879 56.0703 135.888L56.2692 135.875H56.2289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0425 137.345C64.9081 137.412 64.7189 137.515 64.4681 137.67C64.292 137.779 64.144 137.882 64.0335 137.964C64.1092 138.403 64.1458 138.897 64.1457 139.437C64.1449 141.723 63.5012 143.169 62.1545 143.169C60.9574 143.169 60.1798 141.847 60.1805 139.52C60.1813 137.082 61.0196 135.788 62.1719 135.788C62.7702 135.788 63.224 136.067 63.5444 136.567C63.6777 136.469 63.8728 136.32 64.0571 136.154C64.1652 136.06 64.2611 135.953 64.3427 135.836C63.8456 135.201 63.1492 134.852 62.247 134.852C60.2718 134.852 59.1166 136.548 59.1157 139.55C59.1447 142.51 60.1791 144.105 62.0794 144.105C64.234 144.105 65.2829 142.551 65.2839 139.508C65.2841 138.697 65.2043 137.97 65.0425 137.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8874 135.995C65.8662 136.105 65.715 136.328 65.5357 136.492C65.3754 136.638 65.0197 136.77 64.5307 136.976C64.2978 137.074 64.0553 137.183 63.8293 137.305C63.7482 137.348 63.6693 137.394 63.5936 137.441C63.5909 137.443 63.5881 137.445 63.5851 137.447C63.5707 137.456 63.5559 137.465 63.5416 137.474C63.5164 137.49 63.4917 137.506 63.4678 137.523C63.3248 137.622 63.1911 137.733 63.0681 137.855C63.1858 137.682 63.3629 137.479 63.5573 137.273C63.572 137.258 63.5873 137.242 63.6022 137.226C63.6054 137.223 63.6083 137.221 63.6111 137.217C63.6617 137.164 63.7131 137.111 63.7644 137.059C63.977 136.842 64.1906 136.633 64.3525 136.467C64.4381 136.382 64.5187 136.293 64.5939 136.2C64.7487 135.993 64.7266 135.74 64.7021 135.614C64.702 135.613 64.7019 135.613 64.7015 135.612C64.7012 135.612 64.7007 135.611 64.7002 135.611C64.6997 135.61 64.699 135.61 64.6983 135.61C64.6977 135.609 64.697 135.609 64.6963 135.609C64.6956 135.609 64.6949 135.61 64.6943 135.61C64.6937 135.61 64.6931 135.611 64.6927 135.611C64.6923 135.612 64.692 135.613 64.6918 135.613C64.6916 135.614 64.6916 135.615 64.6917 135.615C64.6983 135.783 64.6519 135.949 64.559 136.09C64.511 136.162 64.4166 136.251 64.2938 136.354C64.125 136.496 63.9025 136.664 63.6726 136.849C63.6611 136.858 63.6493 136.867 63.6376 136.877C63.6349 136.879 63.632 136.881 63.6289 136.884C63.6146 136.896 63.6 136.908 63.5848 136.92C63.5777 136.926 63.5715 136.931 63.5644 136.937C63.5572 136.943 63.5501 136.948 63.5427 136.955C63.5356 136.961 63.5277 136.967 63.5205 136.974C63.4387 137.04 63.3572 137.11 63.2782 137.181C63.2778 137.181 63.2775 137.181 63.2772 137.182C63.2769 137.182 63.2767 137.182 63.2767 137.183C63.2618 137.196 63.2466 137.209 63.2315 137.223C63.2272 137.227 63.2228 137.231 63.219 137.235C63.1123 137.332 63.0109 137.434 62.9152 137.541C62.7958 137.678 62.6906 137.826 62.6011 137.983C62.6007 137.983 62.6003 137.983 62.6001 137.983C62.5998 137.984 62.5996 137.984 62.5995 137.985C62.5964 137.99 62.5934 137.996 62.5905 138.001C62.5663 138.043 62.5442 138.086 62.5231 138.127C62.4422 138.288 62.3752 138.455 62.323 138.627C62.2711 138.64 62.2212 138.659 62.1743 138.684C61.983 138.789 61.3797 139.275 61.1621 139.513C61.0258 139.662 60.8289 139.766 60.7008 139.823C60.6704 139.837 60.6439 139.848 60.623 139.856C60.6165 139.859 60.6106 139.863 60.6058 139.868C60.601 139.873 60.5974 139.88 60.5951 139.886C60.5928 139.893 60.5919 139.9 60.5926 139.907C60.5932 139.914 60.5953 139.921 60.5987 139.927C60.6277 139.98 60.6618 140.031 60.7007 140.077C60.7569 140.147 60.8277 140.205 60.9082 140.245C61.1323 140.353 61.5166 140.249 61.7705 140.216C62.0242 140.182 62.1808 140.23 62.25 140.339C62.3982 140.572 62.1527 141.179 61.7093 141.388C61.5804 141.449 61.1446 141.587 60.8616 141.689C60.8174 141.705 60.7339 141.735 60.6675 141.757C60.6979 141.879 60.794 142.059 60.8633 142.168C61.1845 142.67 61.6032 142.959 62.159 142.959C62.5796 142.959 62.9457 142.778 63.207 142.506C63.3924 142.307 63.5244 142.066 63.5908 141.805C63.721 141.303 63.6552 140.982 63.6116 140.753C63.5704 140.537 63.5063 140.326 63.4203 140.123C63.2715 139.752 63.1411 139.565 62.9904 139.309C62.9076 139.168 62.8718 139.124 62.951 139.059C62.9845 139.031 63.0199 139.056 63.0579 139.062C63.216 139.086 63.3793 139.096 63.5244 139.008C63.5685 138.979 63.6073 138.943 63.6392 138.902C63.6836 138.847 63.7218 138.785 63.7586 138.733C63.7823 138.699 63.7822 138.671 63.7413 138.65C63.7099 138.633 63.6755 138.617 63.6393 138.603C63.4772 138.537 63.2757 138.498 63.1158 138.573C63.0267 138.615 62.9693 138.661 62.9115 138.698C62.9019 138.705 62.8921 138.71 62.8823 138.716C63.0654 138.475 63.2648 138.246 63.4792 138.031C63.4854 138.025 63.4919 138.018 63.4998 138.011C63.5135 137.998 63.5288 137.984 63.5444 137.969C63.5475 137.967 63.5504 137.964 63.5531 137.962C63.6472 137.879 63.7455 137.802 63.8475 137.729C64.0638 137.573 64.3217 137.41 64.5751 137.254C65.0338 136.973 65.349 136.796 65.5077 136.666C65.7279 136.485 65.8951 136.135 65.8992 135.996C65.8994 135.995 65.899 135.993 65.898 135.992C65.8971 135.991 65.8957 135.99 65.8941 135.99C65.8933 135.989 65.8926 135.99 65.8918 135.99C65.891 135.99 65.8903 135.99 65.8897 135.991C65.8884 135.992 65.8876 135.993 65.8874 135.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5019 141.294C50.5018 141.778 50.2595 142.021 49.775 142.021H48.186L48.1862 141.297H49.4767C49.6536 141.297 49.7421 141.213 49.7422 141.045L49.7423 140.493H48.7895C48.3895 140.493 48.1895 140.314 48.1897 139.954L48.19 138.865C48.1901 138.502 48.3902 138.32 48.7902 138.32H49.8998C50.3019 138.32 50.5028 138.502 50.5027 138.865L50.5019 141.294ZM49.7366 139.583L49.7367 139.218C49.7367 139.102 49.6704 139.043 49.5378 139.043H49.1488C49.0141 139.043 48.9468 139.102 48.9467 139.218L48.9466 139.583C48.9466 139.706 49.0139 139.767 49.1486 139.767H49.5375C49.6702 139.767 49.7366 139.706 49.7366 139.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6729 141.294C52.6728 141.511 52.6135 141.685 52.4948 141.816C52.3701 141.952 52.1982 142.021 51.9791 142.021H50.9238L50.9241 141.258L51.5784 141.255C51.711 141.254 51.8025 141.218 51.8528 141.149C51.893 141.091 51.9131 140.995 51.9132 140.858L51.914 138.32H52.6738L52.6729 141.294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6869 139.04H55.8878C55.6667 139.04 55.5561 139.149 55.5561 139.367L55.5559 139.773H56.1349C56.356 139.773 56.4665 139.902 56.4664 140.161L56.4663 140.493C56.4662 140.911 56.3002 141.271 55.9684 141.576C55.6447 141.872 55.2688 142.021 54.8406 142.021C54.3803 142.021 54.0074 141.89 53.7221 141.629C53.4307 141.362 53.2851 141.004 53.2852 140.556L53.2859 138.323H54.0428L54.042 140.535C54.042 140.772 54.1183 140.956 54.271 141.086C54.4177 141.209 54.6137 141.27 54.8589 141.27C55.1122 141.27 55.3253 141.204 55.4982 141.072C55.6892 140.927 55.7848 140.735 55.7849 140.493H55.4049C55.0029 140.493 54.8019 140.312 54.8021 139.948L54.8024 138.865C54.8025 138.5 55.0036 138.317 55.4056 138.317H56.6871L56.6869 139.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4112 137.665C58.4111 137.765 58.3739 137.852 58.2995 137.926C58.2251 137.999 58.1367 138.035 58.0341 138.035C57.9296 138.035 57.8402 137.999 57.7658 137.926C57.6915 137.852 57.6543 137.765 57.6543 137.665C57.6544 137.562 57.6916 137.475 57.766 137.404C57.8404 137.332 57.9299 137.297 58.0344 137.297C58.1389 137.297 58.2273 137.332 58.2997 137.404C58.374 137.475 58.4112 137.562 58.4112 137.665ZM58.413 141.294C58.4129 141.511 58.3536 141.685 58.235 141.816C58.1103 141.952 57.9384 142.021 57.7193 142.021H56.664L56.6642 141.258L57.3185 141.255C57.4512 141.254 57.5426 141.218 57.5929 141.149C57.6331 141.091 57.6533 140.995 57.6533 140.858L57.6541 138.32H58.414L58.413 141.294Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.45 65.69C166.45 66.0538 166.342 66.4094 166.14 66.7119C165.938 67.0143 165.651 67.2499 165.315 67.389C164.978 67.528 164.609 67.5642 164.252 67.4929C163.895 67.4217 163.567 67.2462 163.311 66.9887C163.054 66.7312 162.879 66.4032 162.808 66.0463C162.738 65.6894 162.775 65.3196 162.915 64.9838C163.054 64.6479 163.291 64.361 163.593 64.1595C163.896 63.958 164.252 63.8508 164.616 63.8516C164.857 63.8516 165.096 63.8992 165.319 63.9916C165.542 64.084 165.744 64.2195 165.914 64.3903C166.085 64.5611 166.22 64.7638 166.312 64.9868C166.404 65.2098 166.451 65.4488 166.45 65.69Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.616 68.811C163.995 68.8149 163.386 68.6338 162.867 68.2907C162.348 67.9476 161.943 67.458 161.703 66.8842C161.464 66.3104 161.4 65.6782 161.52 65.0681C161.641 64.4579 161.94 63.8973 162.379 63.4576C162.819 63.0178 163.38 62.7187 163.99 62.5984C164.6 62.478 165.232 62.5417 165.806 62.7815C166.38 63.0213 166.869 63.4263 167.213 63.945C167.556 64.4637 167.737 65.0727 167.733 65.6946C167.728 66.5195 167.398 67.3092 166.814 67.8925C166.231 68.4759 165.441 68.8059 164.616 68.811ZM164.616 62.9702C164.078 62.9702 163.553 63.1295 163.105 63.428C162.657 63.7265 162.308 64.1509 162.101 64.6475C161.895 65.1442 161.84 65.691 161.943 66.2189C162.047 66.7469 162.304 67.2323 162.683 67.6141C163.062 67.9959 163.546 68.2569 164.073 68.3642C164.6 68.4716 165.147 68.4204 165.646 68.2172C166.144 68.014 166.571 67.6679 166.872 67.2224C167.174 66.777 167.337 66.2522 167.341 65.7142C167.343 65.3548 167.275 64.9984 167.139 64.6656C167.003 64.3328 166.803 64.0301 166.55 63.7751C166.297 63.52 165.995 63.3176 165.664 63.1794C165.332 63.0413 164.976 62.9702 164.616 62.9702Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0363 48.1158C54.0371 48.4796 53.9299 48.8354 53.7284 49.1383C53.5269 49.4411 53.24 49.6774 52.9041 49.8171C52.5683 49.9569 52.1985 49.9939 51.8416 49.9234C51.4847 49.8529 51.1568 49.6781 50.8992 49.4211C50.6417 49.1642 50.4662 48.8366 50.395 48.4798C50.3237 48.1231 50.3599 47.7533 50.4989 47.4171C50.638 47.0809 50.8736 46.7936 51.176 46.5914C51.4785 46.3892 51.8341 46.2813 52.1979 46.2813C52.6848 46.2812 53.1518 46.4744 53.4965 46.8183C53.8411 47.1623 54.0353 47.6289 54.0363 48.1158Z",
    fill: "#F34F42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1947 51.2329C51.5736 51.2368 50.9654 51.0561 50.4471 50.7139C49.9288 50.3717 49.5238 49.8833 49.2834 49.3106C49.0431 48.7379 48.9782 48.1068 49.097 47.4972C49.2157 46.8876 49.5128 46.327 49.9506 45.8864C50.3884 45.4459 50.9472 45.1452 51.556 45.0226C52.1649 44.9 52.7964 44.961 53.3706 45.1978C53.9448 45.4345 54.4357 45.8365 54.7812 46.3526C55.1266 46.8687 55.3111 47.4758 55.3111 48.0969C55.3111 48.9252 54.9834 49.7199 54.3995 50.3075C53.8156 50.895 53.023 51.2277 52.1947 51.2329ZM52.1947 45.3882C51.6503 45.3843 51.1171 45.5424 50.6628 45.8424C50.2086 46.1424 49.8539 46.5708 49.6438 47.073C49.4336 47.5752 49.3777 48.1285 49.4829 48.6626C49.5882 49.1967 49.8499 49.6875 50.2348 50.0724C50.6198 50.4573 51.1105 50.7191 51.6446 50.8243C52.1787 50.9296 52.732 50.8736 53.2342 50.6635C53.7364 50.4533 54.1648 50.0986 54.4648 49.6444C54.7648 49.1901 54.9229 48.6569 54.9191 48.1126C54.9139 47.3916 54.6253 46.7016 54.1154 46.1918C53.6056 45.682 52.9156 45.3933 52.1947 45.3882Z",
    fill: "#F34F42"
  }))), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7234 29.0111C58.3981 25.7497 56.148 22.5 52.1966 22.5C48.2453 22.5 45.9991 25.7654 45.6738 29.0111C45.1759 34.0483 48.5706 38.6112 52.1966 42.7742C55.8226 38.6269 59.2213 34.064 58.7234 29.0111ZM52.1966 32.6332C51.4894 32.6332 50.798 32.4234 50.21 32.0304C49.622 31.6374 49.1638 31.0788 48.8934 30.4254C48.6229 29.7719 48.5523 29.0529 48.6906 28.3593C48.8288 27.6657 49.1697 27.0287 49.6701 26.5288C50.1705 26.029 50.8078 25.6888 51.5016 25.5513C52.1953 25.4138 52.9143 25.4852 53.5675 25.7564C54.2206 26.0276 54.7787 26.4864 55.1711 27.0748C55.5634 27.6633 55.7725 28.3548 55.7717 29.0621C55.7737 29.5327 55.6828 29.9991 55.504 30.4344C55.3252 30.8697 55.0621 31.2655 54.7299 31.5988C54.3977 31.9321 54.0028 32.1965 53.5681 32.3767C53.1333 32.5569 52.6673 32.6494 52.1966 32.6489V32.6332Z",
    fill: "#F34F42"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24146_365316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4659,
    height: 9.25385,
    fill: "white",
    transform: "matrix(1 0 -0.000321484 1 47.4375 134.852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeeroVehicleReserve);
export default __webpack_public_path__ + "static/media/zeeroVehicleReserve.846e3c6ab6ecfd7458909bf9842b369a.svg";
export { ForwardRef as ReactComponent };